import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Card, CardBody, Container,TabContent, TabPane, Collapse, NavLink, NavItem, Nav, Row, Col,Label, Input,Button } from "reactstrap";
import { products, } from "../../common/data/ecommerce";
import {  Modal,ModalBody, ModalHeader} from "reactstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { GetlisteMembers, SaveEvaluateMember } from '../../services/MembersServices/Api';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import classnames from "classnames";
import { UpdateMemeberProfile, DisableUserProfile } from "../../services/ProfileServices/Api";
import { CreateUser, GetlisteUsers, UpdateRoleUser } from "../../services/AuthServices/Api";
import { colors } from "../../helpers/colors";


const GestionUsers = () => {
  const [modalUpdateIsOpen,setmodalUpdateIsOpen] = useState(false)
  const [members,setmembers] = useState([])
  const [User,setUser] = useState()
  const [dropdownValues, setDropdownValues] = useState({});
  const  [openmodal, setopenModal] = useState(false)
  const [activeTabJustify,setactiveTabJustify] = useState("1")
  const [memberSelected , setmemberSelected] = useState()
  const [selectedCity , setselectedCity]  = useState("")
  const [Name , setName]  = useState("")
  const [Prenom , setPrenom]  = useState("")
  const [Password, setPassword] = useState()
  const [RPassword, setRPassword] = useState()
  const [ZoneSelected, setZoneSelected] = useState("")
  const [tel , settel]  = useState("")
  const [adr_res , setadr_res]  = useState("")
  const [adr_ferm , setadr_ferm]  = useState("")
  const [Email, setEmail] = useState()
  const [DaysSelected, setDaysSelected] = useState([])
  const [openmodalevaluate, setopenmodalevaluate] = useState(false)
  const [evaluatYear, setevaluatYear] = useState('')
  const [evaluatCmnt, setevaluatCmnt] = useState('')
  const [OpenForSave,setOpenForSave] = useState(false)
    const optionCity = [
      {
          options: [
              { label: "Casablanca", value: "Casablanca" },
              { label: "Rabat", value: "Rabat" },
              { label: "Marrakech", value: "Marrakech" },
              { label: "Fes", value: "Fes" },
              { label: "Tangier", value: "Tangier" },
          ]
        }
    ];

  const Days = [
    { value: "Flexible", label: "Flexible" },
    { value: "Lundi", label: "Lundi" },
    { value: "Mardi", label: "Mardi" },
    { value: "Mercredi", label: "Mercredi" },
    { value: "Jeudi", label: "Jeudi" },
    { value: "Vendredi", label: "Vendredi" },
    { value: "Samedi", label: "Samedi" },
    { value: "Dimanche", label: "Dimanche" },
  ];



  

  const handleClickMember = (member) =>{
    // if(member['profile']){
      console.log(member)
     
      setactiveTabJustify("1")
      setOpenForSave(false)
      setopenModal(true)
      if(member?.role == 1){
        setZoneSelected({ label: "Superviseur", value:  member?.role })
      } else if(member?.role == 2){
        setZoneSelected({ label: "Intégrateur", value:  member?.role })
      }
      setPassword('')
      setRPassword("")
      setmemberSelected(member)
      setEmail(member?.email)
      setName(member?.nom)
      setPrenom(member?.prenom)
      settel(member?.tel)
      setselectedCity({label: member?.profile?.City, value: member?.profile?.City})
      setadr_res(member?.profile?.adrs_res)
      setDaysSelected( member?.profile?.days_dispo ? JSON.parse(member?.profile?.days_dispo) : [])
      setadr_ferm(member?.profile?.adrs_ferme)

      console.log(member)
    // } else{
    //   toastr.warning("le membre n'a pas encourt compléter leur profil !")
    // }
  }

  const handleClickEvaluate = (member) => {
    setmemberSelected(member)
    setopenmodalevaluate(true)
  }

  const  toggleCustomJustified = (tab) => {
		setactiveTabJustify(tab)
	}

  const  handleSelectCity = async (selectedGroup) => {
    console.log(selectedGroup)
    setselectedCity(selectedGroup);
  };




  const columns = useMemo(
    () => [
      {
        Header: "Nom",
        accessor: "nom",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Prénom",
        accessor: "prenom",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Date de création",
        accessor: "createdAt",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "Accès",
        accessor: "role",
        disableFilters: true,
        filterable: false,
      },
      {
        Header: "action",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <Button
            color="danger"
            onClick={(e) => handleDisableUser(e, row.original.id)} // Passing token and userId
          >
            Supprimer
          </Button>
        ),
        }      
    ],
    [members]
  );

  const Roles = [
    {
      id : 1,
      label : 'Superviseur'
    },
    {
      id : 2,
      label : 'Intégrateur ;'
    },
    

  ]

  const getRolelabel = (id) =>{
    console.log(id)
    const rolelabel = Roles.find((item) => item.id === id)
    return rolelabel['label']
  }

    useEffect(() =>{
      const Data = JSON.parse(localStorage.getItem("authUser"))
      setUser(Data)


      const GetData = async () =>{
        await GetlisteUsers().then(res =>{
          setmembers(res)
          res.map(item =>{
            const label =  getRolelabel(item.role)
            setDropdownValues((prevValues) => ({
              ...prevValues,
              [item.userId]: label,
            }));
          })
        
        }).catch(err =>{
          console.log(err)
        })
      }
      GetData()
    },[])

  const initialOptions = DaysSelected.map(dayLabel => {
      const matchingOption = Days.find(day => day.label === dayLabel);
      return matchingOption || null;
  }).filter(Boolean);

  const handlechangeDays = (value) =>{
    console.log(value)
    const DaySelected = value.map(item => item.value);
    console.log(DaySelected)
    setDaysSelected(DaySelected)
  }

  const updateProfileMemeber = async () =>{
    if(Password != "" && RPassword != "") {
    if(Password != RPassword){
        toastr.warning("Le mot de passe et le mot de passe de confirmation doivent être identiques.")
    } else {
    console.log(memberSelected.profile)
    memberSelected.email = Email
    memberSelected.nom = Name
    memberSelected.tel = tel
    memberSelected.prenom = Prenom
    memberSelected.password = Password

    await UpdateRoleUser(memberSelected).then((res) =>{
        setopenModal(false)
      toastr.success("Role d'utilisateur : " + memberSelected.nom + " était changé avec succès" )

    })
    
    }
    } else {
        memberSelected.email = Email
        memberSelected.nom = Name
        memberSelected.tel = tel
        memberSelected.prenom = Prenom
        await UpdateRoleUser(memberSelected).then((res) =>{
            setopenModal(false)
          toastr.success("Role d'utilisateur : " + memberSelected.nom + " était changé avec succès" )
    
        })
    }

  
  }

  const saveEvaluate = async () =>{
    const Data = JSON.parse(localStorage.getItem("authUser"))

    console.log(memberSelected?.id  + " " + evaluatYear + " " + evaluatCmnt)
    await SaveEvaluateMember(Data.id,memberSelected?.id,evaluatYear,evaluatCmnt,Data.token).then(res =>{
      console.log(res)
      if(res['status'] == "success"){
        toastr.success("L'évaluation a été ajoutée avec succès!")
        setevaluatCmnt('')
        setevaluatYear('')
        setopenmodalevaluate(false)
      }
    }).catch(err =>{
      toastr.success("Erreur lors de l'ajout de l'évaluation. Veuillez réessayer.")

    })
  }

  const handleAddnewUser = () =>{
    setEmail("")
      setName("")
      setPrenom("")
      settel("")
      setPassword('')
      setRPassword("")
      setopenModal(true)
      setOpenForSave(true)

  }
  const  validatePassword = (password) => {
    const minLength = 6;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>~`_\-+=\\[\]/;'|<>]/.test(password);
    const hasDigit = /\d/.test(password);

    if (password.length < minLength) {
        return false;
    }
    if (!hasUpperCase) {
        return false;
    }
    if (!hasSpecialChar) {
        return false;
    }
    if (!hasDigit) {
        return false;
    }

    return true;
}
/*const handleDeleteUser = (event, userId) => {
  event.stopPropagation(); // Empêche la propagation de l'événement

  console.log("UserID à supprimer:", userId);
  console.log("Liste des membres avant suppression:", members);

  if (window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")) {
    setmembers((prevMembers) => {
      const updatedMembers = prevMembers.filter(member => {
        console.log("ID membre actuel:", member.id);
        return member.id !== userId;
      });
      console.log("Liste des membres après suppression:", updatedMembers);
      return updatedMembers;
    });
    toastr.success("Utilisateur supprimé avec succès !");
  }
};*/

const handleDisableUser = async (event, userId, token) => {
  event.stopPropagation(); // Empêche la propagation de l'événement

  if (window.confirm("Êtes-vous sûr de vouloir désactiver cet utilisateur ?")) {
    try {
      // Appel à l'API pour désactiver l'utilisateur
      const response = await DisableUserProfile(token, userId);
      console.log("Réponse de l'API:", response);  // Ajoutez cette ligne pour vérifier la réponse de l'API

      // Mise à jour de l'état local pour désactiver l'utilisateur dans la liste
      setmembers((prevMembers) => prevMembers.map(member => 
        member.id === userId ? { ...member, disable: false } : member
      ));

      toastr.success("Utilisateur désactivé avec succès!");
    } catch (error) {
      // Affiche l'erreur détaillée pour un meilleur débogage
      console.error("Erreur de désactivation d'utilisateur:", error);
      toastr.error("Erreur lors de la désactivation de l'utilisateur. Veuillez réessayer.");
    }
  }
};


// Function to call the backend API to delete a user
const deleteUserFromBackend = async (userId) => {
  // Replace with your actual API call
  const response = await fetch(`/api/users/${userId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${User.token}` // Assuming you have a token for authentication
    }
  });

  if (!response.ok) {
    throw new Error('Failed to delete user');
  }
};

  const handleSaveNewUser = async () =>{
    if(Password != RPassword){
            toastr.warning("Le mot de passe et le mot de passe de confirmation doivent être identiques.")
    } else {

    if(validatePassword(Password)){
        console.log(ZoneSelected)
    const PostData ={
        email : Email,
        login : Email,
        nom : Name,
        tel: tel,
        prenom : Prenom,
        password : Password,
        role : ZoneSelected?.value,
        isadmin : true
    }
    
    await CreateUser(PostData).then((res) =>{
        console.log(res)
        setopenModal(false)
    })}
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Gestion des comptes" breadcrumbItems={[]} />

          <Card>
            <div className="d-flex justify-content-end m-2 mt-2">
              <Button color="success" onClick={handleAddnewUser}>
                Ajouter une utilisateur
              </Button>
            </div>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={members || []}
                isPagination={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                handleClickRow={handleClickMember}
                handleClickEvaluate={handleClickEvaluate}
                dropdownData={dropdownValues}
                userData={User}
              />
            </CardBody>
          </Card>

          <Modal size="xl" isOpen={openmodal} toggle={() => setopenModal(false)}>
            <ModalHeader>
              Information membre
              <Button
                close
                onClick={() => setopenModal(false)}
                style={{ position: 'absolute', top: '10px', right: '10px' }}
              />
            </ModalHeader>
            <ModalBody>
              <React.Fragment>
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="basicpill-firstname-input1">Prénom</Label>
                      <Input type="text" className="form-control" id="basicpill-firstname-input1" value={Name} onChange={(e) => setName(e.target.value)} />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="basicpill-prenom-input">Prénom</Label>
                      <Input type="text" className="form-control" id="basicpill-prenom-input" value={Prenom} onChange={(e) => setPrenom(e.target.value)} />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="form-label">Zone</Label>
                      <Select
                        value={ZoneSelected}
                        onChange={(zone) => setZoneSelected(zone)}
                        options={[
                          { label: "Superviseur", value: 1 },
                          { label: "Intégrateur", value: 2 },
                        ]}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="basicpill-phoneno-input3">Téléphone</Label>
                      <Input type="text" className="form-control" id="basicpill-phoneno-input3" onChange={(e) => settel(e.target.value)} value={tel} />
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="basicpill-lastname-input2">Adresse e-mail</Label>
                      <Input type="text" className="form-control" id="basicpill-lastname-input2" value={Email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="basicpill-phoneno-input3">Mot de passe</Label>
                      <Input type="password" className="form-control" id="basicpill-phoneno-input3" onChange={(e) => setPassword(e.target.value)} value={Password} />
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="basicpill-lastname-input2">Répéter le mot de passe</Label>
                      <Input type="password" className="form-control" id="basicpill-lastname-input2" value={RPassword} onChange={(e) => setRPassword(e.target.value)} />
                    </div>
                  </Col>
                  <span style={{ color: "#838383", fontSize: 13 }}>Le mot de passe doit contenir au moins 6 caractères, un caractère spécial, une lettre majuscule et un chiffre</span>
                </Row>
              </React.Fragment>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 10 }}>
                {OpenForSave === false ? (
                  <Button type="button" color="primary" className="waves-effect waves-light" onClick={updateProfileMemeber}>
                    Mise à jour
                  </Button>
                ) : (
                  <Button type="button" color="primary" className="waves-effect waves-light" onClick={handleSaveNewUser}>
                    Enregistrer
                  </Button>
                )}
              </div>
            </ModalBody>
          </Modal>

          <Modal size="xl" isOpen={openmodalevaluate} toggle={() => setopenmodalevaluate(false)}>
            <ModalHeader toggle={() => setopenmodalevaluate(false)}>
              Evaluation le membre : {memberSelected?.NomComplet}
              <Button close onClick={() => setopenmodalevaluate(false)} />
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg="4">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="basicpill-address-input2">Année d'évaluation</Label>
                    <Input type="text" className="form-control" id="basicpill-phoneno-input3" onChange={(e) => setevaluatYear(e.target.value)} value={evaluatYear} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg="12">
                  <div className="mb-3">
                    <Label className="form-label" htmlFor="basicpill-address-input2">Commentaires</Label>
                    <Input type="textarea" className="form-control" id="basicpill-phoneno-input3" onChange={(e) => setevaluatCmnt(e.target.value)} value={evaluatCmnt} />
                  </div>
                </Col>
              </Row>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 10 }}>
                <Button type="button" color="primary" className="waves-effect waves-light" onClick={saveEvaluate}>
                  Sauvegarder
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GestionUsers;
